import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../styles/AccountTools.css';

const PaymentsCredits = () => {
  const { user } = useAuth();
  const isHelper = String(user?.currentAppRole || '').toUpperCase() === 'HELPER';

  return (
    <main className="tool-page">
      <div className="tool-header">
        <div>
          <h1>Payments &amp; Credits</h1>
          <p>Manage payment methods, issued payments, earnings, and Olitask credits.</p>
        </div>
      </div>

      <div className="payments-menu-grid">
        <Link to="/account/payments/wallet" className="payments-menu-tile payments-menu-tile-primary">
          <span className="payments-menu-icon" aria-hidden>💳</span>
          <div className="payments-menu-text">
            <strong>Wallet</strong>
            <span>Payment Methods</span>
          </div>
          <span className="payments-menu-chevron" aria-hidden>›</span>
        </Link>

        <Link to="/account/payments/charges" className="payments-menu-tile">
          <span className="payments-menu-icon payments-menu-icon-outgoing" aria-hidden>⬆️</span>
          <div className="payments-menu-text">
            <strong>Charges</strong>
            <span>Issued Payments</span>
          </div>
          <span className="payments-menu-chevron" aria-hidden>›</span>
        </Link>

        {isHelper && (
          <Link to="/account/payments/earnings" className="payments-menu-tile">
            <span className="payments-menu-icon payments-menu-icon-incoming" aria-hidden>⬇️</span>
            <div className="payments-menu-text">
              <strong>Earnings</strong>
              <span>Received Payments</span>
            </div>
            <span className="payments-menu-chevron" aria-hidden>›</span>
          </Link>
        )}

        <Link to="/account/credits" className="payments-menu-tile">
          <span className="payments-menu-icon payments-menu-icon-credits" aria-hidden>💰</span>
          <div className="payments-menu-text">
            <strong>Credits</strong>
            <span>Rewards &amp; Available Credits</span>
          </div>
          <span className="payments-menu-chevron" aria-hidden>›</span>
        </Link>
      </div>
    </main>
  );
};

export default PaymentsCredits;
